import { Record } from 'immutable'

export class SurchargeType extends Record({
    id: undefined,
    name: undefined,
}) {}
